import React from "react";
import { InputAdornment, TextField, FormControl } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { useTranslation } from "react-i18next";
function SearchInput({ searchText, handleSearchInputChange }) {
  const { t } = useTranslation()
  return (
    <FormControl>
    <TextField
      label={t("search")}
      variant="outlined"
      size="small"
      //fullWidth
      //style={{ maxWidth: '300px' }}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon />
          </InputAdornment>
        ),
      }}
      value={searchText}
      onChange={handleSearchInputChange}
    />
    </FormControl>
  );
}

export { SearchInput };
